import React, { useLayoutEffect } from "react"
import { projectsData } from "../utils"
import HorizontalScrollSection from "../horizontal-scroll-section"
import { useLocation } from "@reach/router"
import { Link } from "gatsby"
import MobileHorizontalSection from "../mobile-horizontal-section"
const CommonDetails = ({ data }) => {
  const location = useLocation()
  const pathname = location.pathname
  const activeProjectId = pathname.split("/")[2]

  useLayoutEffect(() => {
    if (activeProjectId) {
      const projectButton = document.getElementById(activeProjectId)
      if (projectButton) {
        const parentContainer = projectButton.parentElement
        const scrollToPosition = projectButton.offsetLeft
        parentContainer.scrollTo({
          left: scrollToPosition,
          behavior: "smooth",
        })
      }
    }
  }, [activeProjectId])

  return (
    <>
      <section className=" bg-white-100 items-start flex flex-col gap-12 md:gap-[6.75rem]  py-[4.75rem] pb-8 md:py-[7.75rem]">
        <div className="w-full flex md:px-20 md:pe-10 xll:pe-20 px-6 flex-col gap-4 items-start   xl:px-20 ">
          <h4 className="flex text-gray-500 text-lg lg:text-2xl items-center tracking-tight-2% lg:tracking-tight-4% gap-2">
            {" "}
            <div className="w-[8px]  inline-block rounded-full h-[8px] bg-blue-100"></div>
            Projects
          </h4>
          <h3 className="text-gray-100 text-[3.7rem] md:text-7xl  text-end lg:text-8xl tracking-tight-2% lg:tracking-tight-7%">
            All Projects
          </h3>
        </div>
        <div className="grid ps-0 md:ps-16  gap-x-4 md:gap-x-12   w-full custom-scrollbar grid-flow-col   overflow-x-scroll  ">
          {projectsData.map((item, index) => (
            <div
              key={index}
              className={
                "flex  min-w-[120px] md:min-w-[200px] flex-col items-center gap-4 "
              }
              id={item.id}
            >
              <Link
                to={item.url}
                className={`${activeProjectId === item.id ? "bg-blue-100" : "bg-white-250"}   cursor-pointer group hover:bg-blue-100 transition-all delay-200 ${item.hasLongWidth ? "p-3" : "p-4 md:p-5"}  rounded-[50%]  flex items-center justify-center h-[50px] md:h-[72px] w-[50px] md:w-[72px]`}
              >
                <img
                  src={item.icon}
                  alt={item.label}
                  loading="lazy"
                  className={`${activeProjectId === item.id ? "filter brightness-0 contrast-100 invert" : ""}  delay-200 transition-all scale-[1.3]  group:filter group-hover:brightness-0 group-hover:contrast-100 group-hover:invert flex-shrink-0  object-contain`}
                />
              </Link>
              <div>
                <h2 className="text-gray-100  text-center text-base  lg:text-2xl tracking-tight-2% lg:tracking-tight-4%">
                  {item.label}
                </h2>
              </div>
            </div>
          ))}
        </div>{" "}
      </section>
      {/* tablet and web */}

      <div className="hidden md:block">
        <HorizontalScrollSection data={data} />
      </div>
      {/* mobile */}
      <div className="block md:hidden ">
        <MobileHorizontalSection data={data} />
      </div>
    </>
  )
}

export default CommonDetails
